export const commercialTicketsQueryKeys = {
  all: ["commercial-tickets"] as const,
  tickets: (structureId: string, eventId?: string) =>
    eventId
      ? [...commercialTicketsQueryKeys.all, "tickets", structureId, eventId] as const
      : [...commercialTicketsQueryKeys.all, "tickets", structureId] as const,
  remaining: (structureId: string, eventId: string) =>
    [...commercialTicketsQueryKeys.all, "remaining", structureId, eventId] as const,
  info: (structureId: string) =>
    [...commercialTicketsQueryKeys.all, "info", structureId] as const,
};

export default commercialTicketsQueryKeys;
